// import './style.css'
import { Badge } from 'react-bootstrap'
import { dispatchCustomEvent } from '../../../utils/dispatch';
import "./style.css"
import { useEffect, useState } from 'react';
import LoadingBtn from '../../atoms/loadingBtn/view';
import { lang } from '../../../utils/langs';

function ButtonBasic({ id, icon, title, type, className, style, disabled, hidden, onClick, loadingColor, showLoading, modalID, children, badge: badgeProp }) {

    const [showloading, setShowLoading] = useState(false)
    const [isToggleOn, setIsToggleOn] = useState(false)
    const [loading, setLoading] = useState(false)
    const [badge, setBadge] = useState(badgeProp || 0)

    useEffect(() => {
        window.addEventListener('loading-btn', handleEvent);
        window.addEventListener(id ? 'loading-btn-' + id : 'loading-btn', handleEvent);
        return () => {
            window.removeEventListener('loading-btn', handleEvent);
            window.removeEventListener(id ? 'loading-btn-' + id : 'loading-btn', handleEvent);
        };
    }, [])

    useEffect(() => { setBadge(badgeProp || 0) }, [badgeProp])

    function handleKeyDown(event) {
        if (event.key === "Enter") {
            event.preventDefault();  // Evitar el comportamiento por defecto
        }
    }

    function handleEvent() {
        setLoading(false)
    }

    function handleClick(e) {
        if (e && e.stopPropagation) e.stopPropagation(); // Apply stopPropagation directly in handleClick
        setLoading(true); // Keep original loading state
        dispatchCustomEvent('modal' + modalID, { eventKey: id }); // Use modalID and pass eventKey
        setIsToggleOn(!isToggleOn); // Keep original toggle state
        if (onClick) onClick(e); // Call onClick if it exists, passing the event
        if (showLoading) setShowLoading(showLoading); // Keep original showLoading logic
    }

    return (
        <button
            style={style ? style : {}}
            id={id ? "modal-btn-basic-" + id : "modal-btn-basic"}
            aria-disabled="true"
            disabled={disabled ? disabled : false}
            className={`${className || ''} ${
                type === "topbar" ? 'buttonTopBar' :
                    type === "option" ? 'buttonOption' :
                        type === "pill-primary" ? 'buttonPillPrimary' :
                            type === "pill-secondary" ? 'buttonPillSecondary' :
                                type === "danger" ? 'buttonDanger' :
                                    type === "success" ? 'buttonSuccess' :
                                        type === "cancel" ? 'buttonCancel' :
                                            type === "outline-danger" ? 'buttonOutlineDanger' :
                                                'buttonBasic'
            }`.trim()}
            onClick={handleClick}
            type={type === "pill-primary" || type === "pill-secondary" ? "button" : (type ? type : "button")}
            hidden={hidden ? hidden : false}
            onKeyDown={handleKeyDown}
        >
            <LoadingBtn loading={loading && showloading} color={loadingColor ? loadingColor : "white"}>
                {children}
                {icon}
                {lang('es', title)}
                {
                    badge > 0 && (<Badge style={{ marginLeft: "10px" }} bg="danger">{badge}</Badge>)
                }
            </LoadingBtn>
        </button>
    )

}

export default ButtonBasic
